var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.58915 3.99998L7.5679 1.02122C7.64601 0.943083 7.68989 0.837121 7.68989 0.726636C7.68989 0.616151 7.64601 0.510189 7.5679 0.432053C7.48976 0.35394 7.3838 0.310059 7.27331 0.310059C7.16283 0.310059 7.05687 0.35394 6.97873 0.432053L3.99998 3.41081L1.02165 0.432053C0.943511 0.35394 0.837549 0.310059 0.727064 0.310059C0.616578 0.310059 0.510616 0.35394 0.43248 0.432053C0.354367 0.510189 0.310486 0.616151 0.310486 0.726636C0.310486 0.837121 0.354367 0.943083 0.43248 1.02122L3.41081 3.99998L0.43248 6.97872C0.354367 7.05686 0.310486 7.16282 0.310486 7.27331C0.310486 7.38379 0.354367 7.48975 0.43248 7.56789C0.510602 7.64603 0.616566 7.68995 0.727064 7.68997C0.837561 7.68995 0.943525 7.64603 1.02165 7.56789L3.99998 4.58914L6.97873 7.56789C7.05685 7.64603 7.16282 7.68995 7.27331 7.68997C7.38381 7.68995 7.48977 7.64603 7.5679 7.56789C7.64601 7.48975 7.68989 7.38379 7.68989 7.27331C7.68989 7.16282 7.64601 7.05686 7.5679 6.97872L4.58915 3.99998Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.3ec0641163376b5cc3ec6c9fc1b7346c.svg";
export { ForwardRef as ReactComponent };